<template>
  <div>
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
  <g clip-path="url(#clip0_6182_7373)">
    <path d="M19.9951 20.7977L20.0001 20.7969V13.4619C20.0001 9.87354 19.2276 7.10938 15.0326 7.10938C13.0159 7.10938 11.6626 8.21604 11.1101 9.26521H11.0517V7.44437H7.07422V20.7969H11.2159V14.1852C11.2159 12.4444 11.5459 10.761 13.7017 10.761C15.8259 10.761 15.8576 12.7477 15.8576 14.2969V20.7977H19.9951Z" fill="#2E5FE3"/>
    <path d="M0.330078 7.44531H4.47675V20.7978H0.330078V7.44531Z" fill="#2E5FE3"/>
    <path d="M2.40167 0.796875C1.07583 0.796875 0 1.87271 0 3.19854C0 4.52438 1.07583 5.62271 2.40167 5.62271C3.7275 5.62271 4.80333 4.52438 4.80333 3.19854C4.8025 1.87271 3.72667 0.796875 2.40167 0.796875Z" fill="#2E5FE3"/>
  </g>
  <defs>
    <clipPath id="clip0_6182_7373">
      <rect width="20" height="20" fill="white" transform="translate(0 0.796875)"/>
    </clipPath>
  </defs>
</svg>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>